import Minus from "../AddCustomers/Icons/minus.svg";
import { BorderedDropDown } from "../../HouseStyle/Components/DropDowns";
import { BorderedTextInput } from "../../HouseStyle/Components/Inputs";
import { useState, useEffect } from "react";
import middleware from "../../Api/Middleware";

const Phonenumber = ({setPhoneCode, index, handlePhoneNumberChange, phonenumber, removePhoneNumberField, removable = true}) => {
    const [phoneOptions, setPhoneOptions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCountryCodes = async () => {
            try {
                const response = await middleware.get(`/countryCodes`);
                // Extract the array from response (response.data.data based on API structure)
                const countryData = Array.isArray(response.data) ? response.data : response.data.data;
                
                if (!countryData || !Array.isArray(countryData)) {
                    throw new Error("Invalid response format");
                }

                // Sort by order_by first, then alphabetically by country name
                const sortedData = countryData.sort((a, b) => {
                    if (a.order_by !== b.order_by) {
                        return b.order_by - a.order_by; // Higher order_by first
                    }
                    return a.country.localeCompare(b.country);
                });

                const options = sortedData.map((country, index) => ({
                    title: `${country.country} (+${country.phone_prefix})`,
                    value: country.phone_prefix.toString()
                }));

                // Add a disabled separator after the first 3 items (order_by > 0)
                const topCountries = options.filter((_, index) => sortedData[index].order_by > 0);
                const restCountries = options.filter((_, index) => sortedData[index].order_by === 0);
                
                const finalOptions = [
                    ...topCountries,
                    { title: "", value: "", disabled: true },
                    ...restCountries
                ];

                console.log("Fetched Country Codes:", finalOptions);
                setPhoneOptions(finalOptions);
            } catch (error) {
                console.error("Error fetching country codes:", error);
                // Fallback to default options if API fails
                setPhoneOptions([
                    { title: "Nederland (+31)", value: "31" },
                    { title: "België (+32)", value: "32" },
                    { title: "Duitsland (+49)", value: "49" }
                ]);
            } finally {
                setLoading(false);
            }
        };

        fetchCountryCodes();
    }, []);

    console.log("Phone Options:", phoneOptions);

    return <div key={index} className="d-flex gap-2">
        <BorderedDropDown
            size="m"
            searchable={true}
            placeholder="Selecteer een landcode"
            selectedValue={phonenumber.country_phone_prefix?.toString()}
            setSelectedValue={(phone_prefix) => setPhoneCode(phone_prefix)}
            options={phoneOptions}
        />

        <BorderedTextInput
            size="m"
            type="text"
            placeholder='Vul hier het telefoonnummer in.'
            required={true}
            inputValue={phonenumber.phone_number?.toString() || ''}
            setInputValue={(e) => handlePhoneNumberChange(e)}
        />

        {removable &&
        <img
            className='removeIconSizeModals'
            src={Minus}
            onClick={() => removePhoneNumberField(index)}
            alt="Remove"
            style={{ cursor: 'pointer', width: "3%" }}
        />}
    </div>
}

export default Phonenumber;